














import { Vue, Component, Prop } from 'vue-property-decorator';
import VirtualMediaComponent from '@/app/presenter/components/virtual-media-component.vue';
import { EventStream, EventStreamSymbol } from '@/app/event-stream/event-stream';
import { lazyInject } from '@/app/container';
import { HelpPopupOpenedEventName, HelpPopupOpenedEvent } from '@/app/presenter/events/help-popup-events';
import { TranslateResult } from 'vue-i18n';
import i18n from '@/plugins/i18n';

@Component({
  components: {
    VirtualMediaComponent
  }
})
export default class HelpPopupComponent extends Vue {
  @lazyInject(EventStreamSymbol)
  private eventStream: EventStream;

  @Prop({
    default: false
  })
  public video: boolean;

  @Prop()
  public title: string;

  @Prop()
  public content: string;

  @Prop()
  public color: string;

  @Prop({
    default: false
  })
  public hasTaskHeader: boolean;

  @Prop({
    default: false
  })
  public elementHelp: boolean;

  public visible: boolean = false;
  public listenerId: string;

  public toggle(): void {
    if (this.visible) this.close();
    else {
      this.open();
    }
  }

  public open(): void {
    this.eventStream.dispatch({
      name: HelpPopupOpenedEventName,
      payload: {
        status: 'opened'
      }
    } as HelpPopupOpenedEvent);

    this.visible = true;

    $(document).off('click.help-popup').on('click.help-popup', () => {
      this.close();
    });
  }

  public close(): void {
    this.visible = false;
  }

  private mounted(): void {
    this.listenerId = this.eventStream.listen(HelpPopupOpenedEventName, () => {
      this.close();
    });
  }

  private beforeDestroy(): void {
    if (this.listenerId) {
      this.eventStream.removeListener(HelpPopupOpenedEventName, this.listenerId);
    }
  }

  private t(key: string, params: any = {}): TranslateResult {
    return i18n.t(key, params);
  }
}
